import React, { useRef } from "react";
import { Button } from "@sscs/ui";
import { ButtonColor, ButtonSize } from "Types";
import { useConfirmButton } from "./useConfirmButton";

export type ConfirmButtonProps = {
  onClick: () => void;
  delay?: number;
  className?: string;
  size?: ButtonSize;
  color?: ButtonColor;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  isFullWidth?: boolean;
};

const ConfirmButton = ({
  onClick,
  delay,
  className,
  size = "medium",
  color = "secondary",
  children,
  icon,
  isFullWidth = false,
}: ConfirmButtonProps): React.JSX.Element => {
  const buttonContainerRef = useRef<HTMLDivElement>(null);

  const { isSwapped, onConfirm, onSwap, width } = useConfirmButton({
    onClick,
    delay,
    buttonContainerRef,
  });

  return (
    <div ref={buttonContainerRef} className={className}>
      {isSwapped ? (
        <Button
          color="error"
          onClick={onConfirm}
          style={{ width }}
          startIcon={icon}
          isFullWidth={isFullWidth}
        >
          Confirm?
        </Button>
      ) : (
        <Button
          size={size}
          color={color}
          onClick={onSwap}
          startIcon={icon}
          isFullWidth={isFullWidth}
        >
          {children}
        </Button>
      )}
    </div>
  );
};

export default ConfirmButton;
